<div class="flex items-center gap-1">
  @if (label() || !isDisabled()) {
    <button
      mat-stroked-button
      (click)="fileInput.click()"
      [disabled]="isDisabled()"
      class="flex-shrink-0"
    >
      <mat-icon>{{ uploadIcon() }}</mat-icon>
      {{ label() | siaTranslate }}
    </button>
  }
  @if (value()?.length || fileName()) {
    @if (value()?.length > 1) {
      <button
        mat-icon-button
        (click)="downloadFolder(); $event.stopPropagation()"
        [siaTooltip]="'Scarica zip'"
        [disabled]="
          !originalFiles() || !originalFiles()?.length || changed() || deleted()
        "
      >
        <mat-icon>folder</mat-icon>
      </button>
      <span
        class="flex flex-row items-center gap-2 text-sm font-semibold truncate"
        [class.cursor-pointer]="!isDisabled()"
        [class]="isDisabled() ? '!text-[var(--mat-sys-outline)]' : ''"
        [matMenuTriggerFor]="!isDisabled() ? fileMenu : null"
      >
        {{ value()?.length }} {{ 'File Selezionati' | siaTranslate }}
      </span>
      <button
        mat-icon-button
        class="error"
        (click)="clearValue()"
        [disabled]="isDisabled()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-menu #fileMenu="matMenu">
        @for (file of value() ?? []; track file) {
          <div
            style="padding-right: unset !important"
            mat-menu-item
            (click)="
              !originalFiles() ||
              !originalFiles()?.length ||
              changed() ||
              deleted()
                ? ''
                : downloadFile(file.name)
            "
          >
            <div
              style="
                display: flex;
                width: 100%;
                gap: 0.5rem;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;
              "
            >
              <span style="flex: 1; min-width: 0">{{ file.name }}</span>
              <button
                mat-icon-button
                (click)="removeFile(file); $event.stopPropagation()"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: unset !important;
                "
              >
                <mat-icon
                  style="
                    color: var(--mat-sys-error);
                    margin-right: unset !important;
                  "
                  >close</mat-icon
                >
              </button>
            </div>
          </div>
        }
      </mat-menu>
    } @else {
      <span
        class="text-sm truncate cursor-pointer"
        [siaTooltip]="'Scarica'"
        (click)="
          !originalFiles() || !originalFiles()?.length || changed() || deleted()
            ? ''
            : downloadFile()
        "
      >
        {{ fileName() ? fileName() : ('Nessun file caricato' | siaTranslate) }}
      </span>

      <button
        mat-icon-button
        [disabled]="isDisabled()"
        class="error"
        (click)="clearValue()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  } @else {
    <span class="text-sm truncate">{{
      fileName() ? fileName() : ('Nessun file caricato' | siaTranslate)
    }}</span>
  }
  <input
    hidden
    #fileInput
    type="file"
    [accept]="allowedExtensions()"
    [multiple]="allowMultipleFiles()"
    (change)="chooseFile(fileInput.files)"
    [id]="id() ?? ''"
    [tabindex]="tabDisabled() ? '-1' : '0'"
  />
</div>
@if (showBottomMargin()) {
  <div style="height: 22px"></div>
}
